export default "__VITE_ASSET__Bz0YBcJT__"